<template>
	<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
		@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
		<template #default>
			<el-form ref="form" :model="form" label-width="80px" size="mini">
				<el-form-item label="付款金额">
					<el-input v-model="form.amt" readonly></el-input>
				</el-form-item>
				<el-form-item label="入库金额">
					<el-input v-model="form.debt" readonly></el-input>
				</el-form-item>
				<el-form-item label="预付款余额">
					<el-input v-model="form.available" readonly></el-input>
				</el-form-item>
				<el-form-item label="结算金额">
					<el-input-number :precision="2" :step="0.01" v-model="form.settlementamount" @change="change"></el-input-number>
				</el-form-item>
				<el-form-item label="优惠金额">
					<el-input v-model="form.round" readonly></el-input>
				</el-form-item>
			</el-form>
		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			title: {
				type: String,
				default: () => {
					return '优惠金额'
				}
			},
			currentrow: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal_model: false,
				modal_title: '结算信息',
				modal_width: 500,
				modal_height: 500,
				form:{
					amt:0,
					debt:0,
					settlementamount:0,
					round:0,
					available:0,
				}
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				this.form.available = this.currentrow.available?this.currentrow.available:0,
				this.form.amt = this.currentrow.amt?this.currentrow.amt:0,
				this.form.debt = this.currentrow.debt?this.currentrow.debt:0	
				this.form.settlementamount = this.form.debt	
				this.form.round = this.form.debt - this.form.settlementamount
				this.form.round = this.form.round.toFixed(2)
			},
			change(){
				this.form.round = this.form.debt - this.form.settlementamount
				this.form.round = this.form.round.toFixed(2)
			},
			submit() {
				if(this.form.available < this.form.settlementamount){
					this.$confirm('结算金额大于【预付款余额】 是否以欠款模式结算').then(()=>{
						this.$emit('submit',this.form)
						this.modal_cancel()
					})
				}else{
					let obj = {
						type: 6,
						wlnid: this.currentrow.supplierID,
						purchasecode: this.currentrow.billCode,
						stockCode:this.currentrow.stockCode,
						bankAcc: this.currentrow.bankAcc,
						round: this.form.round,
						settlementamount: this.form.settlementamount
					}
					this.$emit('submit',obj)
					this.modal_cancel()
				}
				
				// this.loading = true
				// this.$api.reconciliationcurrent.checkavailable({
				// 	settlementamount: this.form.settlementamount,
				// 	wlnid: this.currentrow.supplierID,
				// }).then((res) => {
				// 	this.loading = false
				// 	if(res ==0){
				// 		this.$confirm('结算金额大于该供应商【预付款余额】 是否以欠款模式结算').then(()=>{
				// 			this.$emit('submit',this.form)
				// 			this.modal_cancel()
				// 		})
				// 	}					
				// }, () => {
				// 	this.loading = false
				// })
				
				

				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>